import { clsx } from 'clsx';
import { forwardRef, type LabelHTMLAttributes } from 'react';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  isRequired?: boolean;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, className, isRequired = false, ...props }, ref) => (
    <label
      ref={ref}
      className={clsx('text-xs font-normal text-foreground-muted', className)}
      {...props}
    >
      {children}
      {isRequired && (
        <span aria-hidden="true" className="text-primary">
          *
        </span>
      )}
    </label>
  )
);

Label.displayName = 'Label';

export { Label };
